module.exports = __webpack_public_path__ + "img/video_recording.6115ce9f.gif";